import { styled } from '@mui/material';
import Image from 'next/image';

export const ImageStyled = styled(Image)<{
  fill?: boolean;
  width?: number | string;
  height?: number | string;
}>`
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  height: ${({ height, fill }) => (fill || !height ? 'auto' : `${height}px`)};
`;
